// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__Xixt_","label":"styles_label__zodrH","caption":"styles_caption__KCc0E","description":"styles_description__EJFeC","content":"styles_content__KeHKm"};